import axios from 'axios'

import { PersistentTokenStorage } from './orul-token-storage'

/**
 * Cliente HTTP do orul-auth.
 *
 * Separado do `api` (que aponta para o toty-service) porque os endpoints de
 * troca de telefone ficaram fora do SDK por decisão do spec do backend — o app
 * os consome direto.
 *
 * ATENÇÃO: os dois backends exigem tokens DIFERENTES.
 *
 * O `orul-auth` valida o Bearer com `GetUserCommand({ AccessToken })`
 * (`auth.service.ts:2037`), e o `GetUser` do Cognito só aceita access token —
 * mandar o idToken devolve "Invalid or expired token" em toda requisição.
 *
 * Já o `phone-sync` do toty-service exige `token_use === 'id'` nos dois tokens
 * que recebe. Por isso o `api` continua usando o `orulTokenManager`, que é
 * alimentado com o idToken, e este cliente lê o access token do storage.
 *
 * A leitura do storage é síncrona e sempre traz o valor corrente: o SDK grava
 * ali durante o `refreshSession()`, então uma sessão recém-renovada já aparece
 * aqui sem depender de nenhum efeito do React ter rodado.
 */
export const orulAuthApi = axios.create({
  baseURL: process.env.REACT_APP_ORUL_AUTH_API_URL,
  timeout: 30000,
})

orulAuthApi.interceptors.request.use(async configs => {
  const accessToken = new PersistentTokenStorage().getTokens()?.accessToken

  if (configs.headers && !!accessToken) {
    configs.headers.authorization = `Bearer ${accessToken}`
  }

  return configs
})
